import { api } from 'api/api';

export interface EventRoleDto {
    id: string;
    entityId: string;
    name: string;
}

export interface CreateEventRoleDto {
    name: string;
}

export interface UpdateEventRoleDto {
    id: string;
    name: string;
}

export const eventRoleApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getEventRoles: builder.query<EventRoleDto[], string>({
            query: (entityId) => `entity/${entityId}/event-roles`,
            providesTags: ['EventRole'],
        }),
        createEventRole: builder.mutation<EventRoleDto, { entityId: string; data: CreateEventRoleDto }>({
            query: ({ entityId, data }) => ({
                url: `entity/${entityId}/event-roles`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['EventRole'],
        }),
        updateEventRole: builder.mutation<void, { entityId: string; id: string; data: UpdateEventRoleDto }>({
            query: ({ entityId, id, data }) => ({
                url: `entity/${entityId}/event-roles/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['EventRole'],
        }),
        deleteEventRole: builder.mutation<void, { entityId: string; id: string }>({
            query: ({ entityId, id }) => ({
                url: `entity/${entityId}/event-roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['EventRole'],
        }),
    }),
});

export const {
    useGetEventRolesQuery,
    useCreateEventRoleMutation,
    useUpdateEventRoleMutation,
    useDeleteEventRoleMutation,
} = eventRoleApi;
